import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Bus } from '@atlas/core';

export const BetBoosterGlobalContext = createContext();

const createBetBoosterGlobalContext = () => {
  const [activeBetBoosterEventId, setActiveBetBoosterEventIdInner] = useState();
  // I suppose that bet booster has 1 insight to let it load data!!
  const [insightsCount, setInsightsCount] = useState(1);

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const handler = ({ insightsCount }) => {
      setInsightsCount(insightsCount);
    };
    Bus.on('insightsCountChanged', handler);

    return () => {
      Bus.off('insightsCountChanged', handler);
    };
  }, []);

  const setActiveBetBoosterEventId = useCallback(newEventId => {
    setActiveBetBoosterEventIdInner(currentEventId => newEventId !== currentEventId && newEventId);
    // I suppose that bet booster has 1 insight to let it load data!!
    setInsightsCount(1);
  }, []);

  return {
    activeBetBoosterEventId,
    insightsCount,
    setActiveBetBoosterEventId,
  };
};

export const BetBoosterGlobalContextProvider = ({ children }) => {
  const value = createBetBoosterGlobalContext();

  return (
    <BetBoosterGlobalContext.Provider value={value}>{children}</BetBoosterGlobalContext.Provider>
  );
};

export const useBetBoosterGlobalContext = () => useContext(BetBoosterGlobalContext);

BetBoosterGlobalContextProvider.propTypes = {
  children: PropTypes.node,
};
